export default {
    buscando: false,
    items: [],
    formValues:[],
    selecionado: ''
}